module.exports = __webpack_public_path__ + "img/course.f0658ed0.webp";